import SelectLocation, { SelectLocationProps } from "./SelectLocation";
export default SelectLocation
export type { SelectLocationProps }